import { render, staticRenderFns } from "./GlobalSearchResults.vue?vue&type=template&id=7711a4ae&scoped=true"
import script from "./GlobalSearchResults.vue?vue&type=script&lang=js"
export * from "./GlobalSearchResults.vue?vue&type=script&lang=js"
import style0 from "./GlobalSearchResults.vue?vue&type=style&index=0&id=7711a4ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7711a4ae",
  null
  
)

export default component.exports